
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(5(13|18|79)|[49]14|021|13|479|698|790|826)|2(84[02]|(09|1|55|94)0|133|374|426|619|638|705)|5(6(26|37|4|91)|19[48]|96[36]|3(09|78|79)|098|282|454|583)|6(3(|8|9)8|(13|42|95)0|(09|53|78)8|(12|52|73)2|419|974)|1(7(15|33|89)|355|657)|8(02[56]|154|206|430|602|63|748|926|992)|7((40|63|80)2|(3|47|91)8|(20|65|79)3|179|195|531|547)|3(44[23]|27[08]|1(06|36|54)|7(17|21|81)|3(42|7|75)|9(2|34|43)|535|63|697)|9(073|258|34|389|446|457|614|725|786|885|9|900))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
